<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as SECURITY_ROLE_TYPES } from '../../../organization/contact/contact-security-role/store'
import { vue } from '@/main'

export default {
  name: 'SecurityRoleMixin',
  created () {
    this.setSecurityRoleList({})
  },
  computed: {
    ...mapGetters({
      securityRoleList: SECURITY_ROLE_TYPES.GENERIC.organization.contactsecurityrole.LIST.GETTERS.list
    }),
    securityRoleOptions () {
      if (this.securityRoleList) {
        return this.prepareListForMultiSelect(this.securityRoleList.results, 'id', ['name'])
      }
      return []
    }
  },
  methods: {
    ...mapActions({
      getSecurityRoleList: SECURITY_ROLE_TYPES.GENERIC.organization.contactsecurityrole.LIST.ACTIONS.setFilters
    }),
    ...mapMutations({
      setSecurityRoleList: SECURITY_ROLE_TYPES.GENERIC.organization.contactsecurityrole.LIST.MUTATIONS.setList
    }),
    onSearchSecurityRole (search) {
      vue.$store.commit('componentLoading', false)
      if (search.length >= 2) {
        const filters = {}
        filters.filter__name__icontains = search
        filters.order_by = '-status'
        this.getSecurityRoleList(filters).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setSecurityRoleList({})
        vue.$store.commit('componentLoading', true)
      }
    },
    getSecurityRoles (formData) {
      const values = []
      if (formData.security_roles) {
        this.securityRoleOptions.forEach(element => {
          if (formData.security_roles.includes(element.id)) {
            values.push({
              id: element.id,
              name: element.name,
              status: element.status
            })
          }
        })
        return values
      }
    },
    setSecurityRoles (formData) {
      if (this.form.security_roles) {
        const list = []
        this.form.security_roles.forEach((row) => list.push(row.id))
        this.$set(formData, 'security_roles', new Set(list))
      } else {
        this.$set(formData, 'security_roles', [])
      }
    },
    removeSecurityRole (item) {
      const securityRoles = this.form.security_roles.filter((sr) => {
        return sr.id !== item.id
      })
      this.$set(this.form, 'security_roles', securityRoles)
      if (this.form.security_roles.length === 0) this.$set(this.form, 'security_roles', null)
    },
    selectSecurityRole (item) {
      if (!this.form.security_roles) {
        this.$set(this.form, 'security_roles', [])
      }
      this.form.security_roles.push(item)
    }
  }
}
</script>
